import { useCallback } from 'react'
import { usePanel } from 'hooks/usePanel'
import { PanelConfig } from 'components/feedback/Overlay/OverlayContext'
import {
  MainBorrowerPricingContext,
  useMainBorrowerPricing
} from '../contexts/main-borrower-pricing/MainBorrowerPricingContext'

export const usePanelWithBorrowerPricingContext = () => {
  const { openPanel: baseOpenPanel, ...rest } = usePanel()
  const contextValue = useMainBorrowerPricing()

  const openPanel = useCallback(
    (panelConfig: PanelConfig, panelContent: JSX.Element) => {
      baseOpenPanel(
        panelConfig,
        <MainBorrowerPricingContext.Provider value={contextValue}>
          {panelContent}
        </MainBorrowerPricingContext.Provider>
      )
    },
    [baseOpenPanel, contextValue]
  )

  return {
    openPanel,
    ...rest
  }
}
